export const session = [
  {
    path: '/session',
    component: () => import(/* webpackChunkName: "session" */ '@/views/session/Session'),
    children: [
      {
        path: 'create',
        components: {
          body: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionEditBody'),
          bar: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionEditBar'),
        },
      },
      {
        path: ':id/edit',
        components: {
          body: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionEditBody'),
          bar: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionEditBar'),
        },
      },
      {
        path: ':id/persons',
        components: {
          body: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionPersonsBody'),
          bar: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionPersonsBar'),
        }
      },
      {
        path: ':id/presentations',
        components: {
          body: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionPresentationsBody'),
          bar: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionPresentationsBar'),
        }
      },
      {
        path: ':id/participations',
        components: {
          body: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionParticipationsBody'),
          bar: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionParticipationsBar'),
        }
      },
    ]
  },
]
